var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1020_1185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78091 20.0001C4.62637 20.0001 4.47529 19.9543 4.34679 19.8685C4.21829 19.7826 4.11813 19.6606 4.05899 19.5178C3.99985 19.3751 3.98437 19.218 4.01453 19.0664C4.04469 18.9148 4.11912 18.7756 4.22841 18.6664L18.6659 4.22885C18.8124 4.08232 19.0112 4 19.2184 4C19.4256 4 19.6244 4.08232 19.7709 4.22885C19.9174 4.37539 19.9998 4.57413 19.9998 4.78135C19.9998 4.98858 19.9174 5.18732 19.7709 5.33385L5.33341 19.7714C5.26092 19.844 5.17479 19.9016 5.07998 19.9408C4.98516 19.9801 4.88353 20.0002 4.78091 20.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2184 20.0001C19.1157 20.0002 19.0141 19.9801 18.9193 19.9408C18.8245 19.9016 18.7384 19.844 18.6659 19.7714L4.22836 5.33385C4.08183 5.18732 3.99951 4.98858 3.99951 4.78135C3.99951 4.57413 4.08183 4.37539 4.22836 4.22885C4.3749 4.08232 4.57364 4 4.78086 4C4.98809 4 5.18683 4.08232 5.33336 4.22885L19.7709 18.6664C19.8802 18.7756 19.9546 18.9148 19.9847 19.0664C20.0149 19.218 19.9994 19.3751 19.9403 19.5178C19.8811 19.6606 19.781 19.7826 19.6525 19.8685C19.524 19.9543 19.3729 20.0001 19.2184 20.0001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1020_1185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.17445e4dd221b6d9da9888a9e90ad17e.svg";
export { ForwardRef as ReactComponent };